/**
 * 画面に出す文が日本語かどうか（2026-09-22）。
 *
 * **英語だけの文を画面へ出さない。**サーバの既定の断り（Forbidden・No message available）、
 * 通信の失敗（Network Error）、画面の中の思わぬ失敗（Cannot read properties of …）は英語で、
 * そのまま出すと、日本語の業務アプリの画面に英語が混ざる。日本語を含まない文は、
 * 呼ぶ側が持っている日本語の文に置き換える。
 */
const JAPANESE = /[぀-ヿ一-鿿]/

/** ひらがな・カタカナ・漢字を1文字でも含むか。 */
export function containsJapanese (text) {
  return JAPANESE.test(String(text == null ? '' : text))
}

/** 日本語を含む文ならそのまま、そうでなければ fallback。 */
export function japaneseOr (text, fallback) {
  return typeof text === 'string' && text.trim() && containsJapanese(text)
    ? text
    : fallback
}
